const client = require('./request/client');
import useBugsnag from 'hooks/useBugsnag';
const { notifyBugsnag } = useBugsnag();



const ENDPOINT = `${process.env.EP_URL}/client_api/merchant_landing.php`;
const TOKEN_ENDPOINT = `${process.env.EP_URL}/client_api/landing_token.php`;

//const ENDPOINT = "http://edmundyeboah.expresspaygh.com/expresspay/website/merchant_landing.php";

// Fetch a single-use guest-signon token bound to this merchant-service. The token
// is consumed once by merchant_landing.php, which prevents replay / direct-endpoint
// abuse and is the chokepoint for the server-side velocity breaker. Returns '' on
// any failure; the backend fails open on an absent token while in observe mode.
const issueLandingToken = async (merchantServiceSrvrtid) => {
  try {
    const res = await client.sendRequest(TOKEN_ENDPOINT, {
      merchant_service_srvrtid: merchantServiceSrvrtid,
    });
    return res && res.status === 0 && res.token ? res.token : '';
  } catch (e) {
    return '';
  }
};

const submitMerchantlandingDetails = async (data) => {

    const landing_token = await issueLandingToken(data.selectedMerchantServiceSrvrtid);

    const requestPayload = {
        amountId: data.amount ? data.amount : "",
        trnamt: data.amount ? data.amount : "",
        merchant_service_srvrtid: data.selectedMerchantServiceSrvrtid,
        "service-description": "",
        payacct: data?.phoneNumber,
        description: `${data.firstName} ${data.lastName}`,
        url: `merchant_landing.php?ms=${data?.selectedMerchantServiceSrvrtid}`,
        "denom-srvrtid": data.selectedDenominationId ? data.selectedDenominationId : "",
        phone_number: data?.phoneNumber,
        first_name: data?.firstName,
        last_name: data?.lastName,
        email: data?.email,
        // Single-use token issued by landing_token.php, consumed once by the backend.
        landing_token,
        // CAPTCHA is also enforced at the edge by AWS WAF via the aws-waf-token
        // cookie (sent automatically with this request).
      }
  
        return await client
        .sendRequest(ENDPOINT, requestPayload)
        .then(function (response) {
            console.log("response::",response);
            const isNotAnError =  response.status === 0 || response.status === 10 || response.status === 11;
            if (isNotAnError) {
                return response;
            } else {
              const error = new Error(response.message);
              notifyBugsnag({ error, metaData: { scope: 'API REQUEST' } });
              return error;
            }
        })
        .catch(function (error) {
            console.log("error::",error);
              notifyBugsnag({ error, metaData: { scope: 'API REQUEST' } });
            return error;
        });
        };
  
  export default {
    submitMerchantlandingDetails,
  };